// extracted by mini-css-extract-plugin
module.exports = {"Container":"Place_Container__3NkiA","PlaceContainer":"Place_PlaceContainer__FnqZq","Space":"Place_Space__1pkg0"};